import { newVersionMiddleware } from '@/adapters/newVersionMiddleware';
import {
  DefaultApi as RocApi,
  Configuration as RocConfiguration
} from '@/types/roc';

function createPublicRocConfiguration(token?: string) {
  return new RocConfiguration({
    basePath: import.meta.env.VITE_API_BASE_PATH_ROC,
    accessToken: token,
    middleware: [
      {
        post: async ({ response }) => newVersionMiddleware(response)
      }
    ]
  });
}

export function createPublicRocClient(token?: string) {
  return new RocApi(createPublicRocConfiguration(token));
}
